export function getFileExtension(nameOrUrl) {
  const clean = (nameOrUrl || '').split('?')[0];
  const parts = clean.split('.');
  return parts.length > 1 ? parts[parts.length - 1].toLowerCase() : '';
}

export function getFileIconColor(type, extension) {
  const t = type || '';
  if (t.includes('audio')) return 'text-teal-500';
  if (t.includes('video')) return 'text-purple-500';
  if (t === 'location') return 'text-red-500';
  if (t === 'contact') return 'text-blue-500';
  if (extension === 'pdf') return 'text-red-500 pdf-extension';
  if (['doc', 'docx'].includes(extension)) return 'text-blue-500';
  if (['xls', 'xlsx'].includes(extension)) return 'text-green-500';
  if (['ppt', 'pptx'].includes(extension)) return 'text-orange-500';
  return 'text-gray-400';
}
